export class WalletConnectError extends Error {
  constructor(message, code = 'wallet-not-connected', stack = null) {
    super(message); // Set the error message
    this.code = code; // Add a custom code property
    this.name = "WalletConnectError"; // Set a custom error name (optional)
    this.stack = stack;
  }
}

export class WalletNotFoundError extends Error {
  constructor(message, code = 'wallet-not-found', stack = null) {
    super(message); // Set the error message
    this.code = code; // Add a custom code property
    this.name = "WalletNotFoundError"; // Set a custom error name (optional)
    this.stack = stack;
  }
}